import { cn } from "@/lib/chillnn/cn";
import { formatDate } from "@/lib/dayjs/format-date";
import { useWindowSize } from "@/lib/react-use/use-window-size";

import { Button } from "../button/button";
import { Calendar } from "../calendar/calendar";
import CalendarIcon from "../icon/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../popover/popover";

import type { CalendarRangeProps } from "../calendar/types/calendar-range";

type Props = Omit<CalendarRangeProps, "mode"> & { className?: string };

export function DatePickerRange({
	selected,
	onSelect,
	hideYear = false,
	canSelectPastDate = false,
	className,
	showPresetOptions = "not-show-preset-options",
}: Props) {
	const from = selected.from || "";

	const { isLaptop } = useWindowSize();

	const numberOfMonths = isLaptop ? 2 : 1;

	const formattedFrom = (() => {
		if (from) {
			if (hideYear) {
				return formatDate(from, "MM月DD日");
			} else {
				return formatDate(from, "YYYY年MM月DD日");
			}
		}

		return "";
	})();

	const to = selected.to || "";
	const formattedTo = (() => {
		if (to) {
			if (hideYear) {
				return formatDate(to, "MM月DD日");
			} else {
				return formatDate(to, "YYYY年MM月DD日");
			}
		}

		return "";
	})();

	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button variant="input-ish" className={cn("w-[340px] justify-start text-left font-normal", className)}>
					<CalendarIcon className="mr-3 h-4 w-4 text-zinc-600" />
					<p className="text-sm text-zinc-600">
						{formattedFrom ? `${formattedFrom} ~ ${formattedTo}` : "日付を選択してください"}
					</p>
				</Button>
			</PopoverTrigger>
			<PopoverContent className="z-[calc(infinity)] w-auto px-6 py-6">
				<Calendar
					mode={"range"}
					selected={selected}
					onSelect={onSelect}
					hideYear={hideYear}
					canSelectPastDate={canSelectPastDate}
					numberOfMonths={numberOfMonths}
					showPresetOptions={showPresetOptions}
				/>
			</PopoverContent>
		</Popover>
	);
}
